(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["extralife-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.elc').forEach((sec) => {
    const tabs = sec.querySelectorAll('[data-elc-filter]');
    const cards = sec.querySelectorAll('[data-elc-tags]');
    const facets = sec.querySelectorAll('[data-elc-facet]');
    const emptyMsg = sec.querySelector('[data-elc-empty]');

    // Функцію винесено в зовнішню область видимості (а не лише всередині
    // `if (cards.length)`), щоб кнопка «Відмінити» в попапі фільтрів теж
    // могла її викликати після скидання чекбоксів.
    const applyFilters = () => {
      const activeTab = sec.querySelector('[data-elc-filter].is-active');
      const wantTag = activeTab ? activeTab.dataset.elcFilter : '*';
      const byGroup = {};
      facets.forEach((cb) => {
        if (!cb.checked) return;
        const g = cb.dataset.elcFacet;
        (byGroup[g] = byGroup[g] || []).push(cb.value);
      });
      let visibleCount = 0;
      cards.forEach((card) => {
        const tags = (card.dataset.elcTags || '').split(',').map((t) => t.trim());
        let visible = wantTag === '*' || tags.includes(wantTag);
        if (visible) {
          for (const g in byGroup) {
            if (!byGroup[g].some((v) => tags.includes(v))) { visible = false; break; }
          }
        }
        card.hidden = !visible;
        if (visible) visibleCount++;
      });
      if (emptyMsg) emptyMsg.hidden = visibleCount !== 0;
      const actionsEl = sec.querySelector('[data-elc-filters-actions]');
      const hasActive = wantTag !== '*' || Object.keys(byGroup).length > 0;
      if (actionsEl) actionsEl.classList.toggle('is-active', hasActive);
      const resetEl = sec.querySelector('[data-elc-filters-reset]');
      if (resetEl) resetEl.hidden = !hasActive;
    };

    // Фільтр-чіпи/фасети мають сенс лише коли є картки товару — але попап
    // фільтрів (нижче) НЕ повинен залежати від їх наявності, тож більше не
    // виходимо з forEach раніше часу через ранній `return`.
    if (cards.length) {
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => {
            const on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          applyFilters();
        });
      });

      facets.forEach((cb) => cb.addEventListener('change', applyFilters));

      // ExtraLife 2026-09-23: ?need=<tag> у URL (лінки з головної) одразу вмикає фільтр «Для чого»
      const needParam = (new URLSearchParams(window.location.search).get('need') || '').toLowerCase().trim();
      if (needParam) {
        facets.forEach((cb) => { if (cb.dataset.elcFacet === 'need' && cb.value === needParam) cb.checked = true; });
        applyFilters();
      }
    }

    // ── Попап фільтрів на мобільному ──
    // Кнопка відкриває .elc-filters як bottom sheet (виїжджає знизу), з
    // підложкою-затемненням. Закриття: хрестик, тап по підложці, Esc або
    // свайп вниз за ручку (drag за pointer-подіями з фолбеком через is-open,
    // якщо смикнули недостатньо — сітка сама повертається на місце).
    const filtersPanel = sec.querySelector('[data-elc-filters-panel]');
    const filtersBackdrop = sec.querySelector('[data-elc-filters-backdrop]');
    const filtersOpenBtn = sec.querySelector('[data-elc-filters-open]');
    const filtersCloseBtn = sec.querySelector('[data-elc-filters-close]');
    const filtersHandle = sec.querySelector('[data-elc-filters-handle]');
    const filtersApplyBtn = sec.querySelector('[data-elc-filters-apply]');
    const filtersResetBtn = sec.querySelector('[data-elc-filters-reset]');

    if (filtersPanel && filtersBackdrop && filtersOpenBtn) {
      const openFilters = () => {
        filtersPanel.classList.add('is-open');
        filtersBackdrop.classList.add('is-open');
        filtersBackdrop.hidden = false;
        filtersOpenBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('elc-filters-lock');
      };

      const closeFilters = () => {
        filtersPanel.classList.remove('is-open');
        filtersBackdrop.classList.remove('is-open');
        filtersOpenBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('elc-filters-lock');
        filtersPanel.style.transition = '';
        filtersPanel.style.transform = '';
        window.setTimeout(() => {
          if (!filtersPanel.classList.contains('is-open')) filtersBackdrop.hidden = true;
        }, 300);
      };

      filtersOpenBtn.addEventListener('click', openFilters);
      filtersCloseBtn?.addEventListener('click', closeFilters);
      filtersBackdrop.addEventListener('click', closeFilters);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && filtersPanel.classList.contains('is-open')) closeFilters();
      });

      // «Застосувати» — фільтри й так оновлюються одразу по кліку на
      // чекбокс, кнопка просто підтверджує вибір і закриває попап.
      filtersApplyBtn?.addEventListener('click', () => {
        applyFilters();
        closeFilters();
      });

      // «Відмінити» — скидає всі чекбокси фасетів і вкладку назад на
      // «Всі», показує знову весь асортимент і закриває попап.
      filtersResetBtn?.addEventListener('click', () => {
        facets.forEach((cb) => { cb.checked = false; });
        tabs.forEach((t) => {
          const isAll = t.dataset.elcFilter === '*';
          t.classList.toggle('is-active', isAll);
          t.setAttribute('aria-selected', isAll ? 'true' : 'false');
        });
        applyFilters();
        closeFilters();
      });

      // Свайп вниз за ручку — закриває попап
      let dragStartY = 0;
      let dragDeltaY = 0;
      let dragging = false;

      const onDragStart = (e) => {
        dragging = true;
        dragStartY = e.clientY;
        filtersPanel.style.transition = 'none';
        filtersHandle.setPointerCapture?.(e.pointerId);
      };
      const onDragMove = (e) => {
        if (!dragging) return;
        dragDeltaY = Math.max(0, e.clientY - dragStartY);
        filtersPanel.style.transform = `translateY(${dragDeltaY}px)`;
      };
      const onDragEnd = () => {
        if (!dragging) return;
        dragging = false;
        filtersPanel.style.transition = '';
        if (dragDeltaY > 90) {
          closeFilters();
        } else {
          filtersPanel.style.transform = '';
        }
        dragDeltaY = 0;
      };

      if (filtersHandle) {
        filtersHandle.addEventListener('pointerdown', onDragStart);
        filtersHandle.addEventListener('pointermove', onDragMove);
        filtersHandle.addEventListener('pointerup', onDragEnd);
        filtersHandle.addEventListener('pointercancel', onDragEnd);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["extralife-products"] && !Shopify.designMode) return;
  try {
    
  // Фільтр-чіпи: показують/ховають картки за тегом товару. Без запитів на сервер.
  document.querySelectorAll('.elp-grid-sec').forEach((sec) => {
    const chips = sec.querySelectorAll('[data-elp-filter]');
    const cards = sec.querySelectorAll('[data-elp-tags]');
    if (!chips.length) return;

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const want = chip.dataset.elpFilter;

        chips.forEach((c) => {
          const on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        cards.forEach((card) => {
          const tags = (card.dataset.elpTags || '').split(',').map((t) => t.trim());
          card.hidden = want !== '*' && !tags.includes(want);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
